module.exports = __webpack_public_path__ + "img/responsive hospitium-06.556d1feb.jpg";